<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="Holiday" name="first">
                <holiday></holiday>
            </el-tab-pane>

            <el-tab-pane label="Feedback Type" name="feedback">
                <feedback-type></feedback-type>
            </el-tab-pane>

            <el-tab-pane label="Banner" name="banner">
                <banner></banner>
            </el-tab-pane>

            <el-tab-pane label="Bank" name="bank">
                <bank></bank>
            </el-tab-pane>

            <el-tab-pane label="Helper Price" name="Helper Price">
                <helper-price></helper-price>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Holiday from "./Holiday";
    import FeedbackType from "./FeedbackType";
    import Banner from "./Banner";
    import Bank from "@/view/eazable/setting/Bank";
    import HelperPrice from "@/view/eazable/helper/HelperPrice";

    export default {
        name: "SettingIndex",
        components: {HelperPrice, Bank, Banner, FeedbackType, Holiday},
        data() {
            return {
                activeName: 'first'
            }
        }
    }
</script>

<style scoped>

</style>
